import { lazy } from "react";

export const MenuCategoriesPageLazy = lazy(
  () => import("@/pages/menuCategoriesPage")
);
export const MenuItemsPageLazy = lazy(() => import("@/pages/menuItemsPage"));

export const AboutUsPageLazy = lazy(() => import("@/pages/aboutUsPage"));

export const SearchPageLazy = lazy(() => import("@/pages/searchPage"));

export const BranchGalleryImagesLazy = lazy(
  () => import("@/pages/aboutUsPage/components/branchGalleryImages")
);

export const PageError404Lazy = lazy(() => import("@/pages/page404"));

export const PageError500Lazy = lazy(() => import("@/pages/page500"));

export const PageMenuUnavailableLazy = lazy(
  () => import("@/pages/menuUnavailable")
);

export const TestPageLazy = lazy(() => import("@/pages/testPage"));
